import React from 'react';

const QuickSearchNavigation = ({ noSearch, isCaseOne, dataMenus }) => {
  return (
    dataMenus?.menuOneLinks?.length > 0 || dataMenus?.menuTwoLinks?.length > 0 ?
    <div
      className={`quick-search-navigation__wrapper ${noSearch == true ? 'quick-search-navigation__wrapper--no-search' : ''
        } ${isCaseOne == true ? 'quick-search-navigation__wrapper--case-one' : ''}
      `}
    >
      <div className={isCaseOne ? 'row' : ''}>
        <div className={isCaseOne ? 'columns small-12' : ''}>
          <div className="quick-search-navigation__content">
            <MenuColumn title={dataMenus.menuOneTitle} items={dataMenus.menuOneLinks} />
            <MenuColumn title={dataMenus.menuTwoTitle} items={dataMenus.menuTwoLinks} />
          </div>
        </div>
      </div>
    </div> : null
  );
};

const MenuColumn = ({ title, items }) => <ul className="quick-search-navigation__menu">
  <li className="[ quick-search-navigation__title ] [ text-medium bold lh-2 color-grey-900 ]">
    {title}
  </li>
  {items?.map((item, index) => (
    <li className="quick-search-navigation__item" key={item.link?.href + index}>
      <a className="text-medium lh-2 color-grey-900" href={item.link?.href}>
        {item.linkTitle ?? item.link?.text}
      </a>
    </li>
  ))}
</ul>

export default QuickSearchNavigation;
